import { LENSES, type LensId } from "../map/presets";

/**
 * LensPicker — the dashboard's mode switch: nine lenses, the one control that
 * decides what the map is showing.
 *
 * MSH: this used to live inside the LAYERS rail section, together with the
 * 22 layer switches. That section was then collapsed by default so the
 * Mayor's Desk could have a real reading window — and the lens picker went
 * with it, because it was inside the same collapsible region. The dashboard
 * had NO visible lens switcher at all. (Independently confirmed: with the
 * section collapsed, `.lens-label-en` count in the DOM = 0.)
 *
 * The two things are not the same task. The lens is the mode — always
 * available. The layer switches are configuration, used occasionally, and
 * they are 792px of content. So they split: the lens sits above the
 * collapsible section, permanently visible; the switches go behind the
 * disclosure.
 *
 * Measured at 1440x900: eyebrow 17px + grid 178px + explainer 103px = 298px,
 * which is what the rail had to give back to make room.
 */
interface Props {
  lens: LensId;
  onLensChange: (l: LensId) => void;
}

export function LensPicker({ lens, onLensChange }: Props) {
  const active = LENSES.find((l) => l.id === lens);

  return (
    <div className="lens-picker">
      <div className="eyebrow" style={{ marginBottom: 6 }}>Lens · เลนส์</div>
      <div className="lens">
        {LENSES.map((l) => (
          <button
            key={l.id}
            onClick={() => onLensChange(l.id)}
            aria-pressed={lens === l.id}
            className={lens === l.id ? "active" : ""}
            title={`${l.label} · ${l.labelTh} — ${l.describe}`}
            aria-label={`${l.label} (${l.labelTh}) — ${l.describe}`}
          >
            <span className="lens-label-en">{l.label}</span>
            <span className="lens-label-th">{l.labelTh}</span>
          </button>
        ))}
      </div>
      <div className="lens-explainer caption">
        {active?.describe}
      </div>
    </div>
  );
}
